import HTTP from '../../Infra/Http'


// import { useNavigate } from 'react-router-dom';

//  const navigate = useNavigate();

// useEffect(() => {
//     // Set the navigate function once when the app loads
//     HTTP.setNavigate(navigate);
// }, [navigate]);



export const sendOtp = async (phone) => {
  return await HTTP.Post('/api/auth/send-otp', { phone });
};

export const verifyOtp = async (phone, otp) => {
  return await HTTP.Post('/api/auth/verify-otp', { phone, otp });
};

export const checkUserAccess = async () => {
  return await HTTP.Post('/check-user', {  });
};


// export const switchAccess = async (phoneNumber, isAdministrator) => {
//   return await HTTP.Put('/api/auth/switch-access', { phoneNumber, isAdministrator });
// };